import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const PrivacyPolicy = () => {
  return (
    <>
      <SEOHead
        title="Privacy Policy | Keski-Uudenmaan Kaihdin"
        description="Privacy policy of Keski-Uudenmaan Kaihdin. Learn how we process your personal data in accordance with the GDPR."
        path="/en/privacy-policy"
        alternatePath="/tietosuoja"
        lang="en"
      />
      <Header />
      <main id="main-content" className="min-h-screen">
        <div className="container max-w-3xl py-16 md:py-24">
          <h1 className="font-display text-3xl md:text-4xl font-bold mb-8">Privacy Policy</h1>
          <p className="text-muted-foreground text-sm mb-8">Last updated: March 4, 2026</p>

          <div className="prose prose-sm max-w-none space-y-6 text-foreground/90">
            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">1. Data Controller</h2>
              <p>
                Tmi Teppo Honkanen<br />
                Business ID: 2303843-1<br />
                Iltalenkki 23, 05400 Jokela, Finland<br />
                Phone: +358 40 583 9991<br />
                Email: info@ku-kaihdin.fi
              </p>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">2. Personal Data Collected</h2>
              <p>We collect the following data through the contact form on our website:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number (optional)</li>
                <li>Message content</li>
              </ul>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">3. Purpose and Legal Basis for Processing</h2>
              <p>Personal data is processed for the following purposes:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong>Responding to inquiries</strong> – Legal basis: performance of pre-contractual measures (GDPR Art. 6(1)(b)).</li>
                <li><strong>Marketing</strong> – Legal basis: legitimate interest of the data controller (GDPR Art. 6(1)(f)). You have the right to object to marketing at any time.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">4. Data Retention</h2>
              <p>
                Data collected through the contact form is retained as long as necessary to process your inquiry and manage any resulting customer relationship. Data used for marketing purposes is deleted when you object to such use.
              </p>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">5. Data Disclosure and Transfers</h2>
              <p>
                Personal data is not disclosed to third parties or transferred outside the EU/EEA.
              </p>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">6. Your Rights</h2>
              <p>Under the GDPR, you have the right to:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Access your personal data</li>
                <li>Request rectification or erasure of your data</li>
                <li>Restrict or object to processing of your data</li>
                <li>Data portability</li>
                <li>Lodge a complaint with the supervisory authority (Office of the Data Protection Ombudsman, <a href="https://tietosuoja.fi/en" target="_blank" rel="noopener noreferrer" className="text-primary underline">tietosuoja.fi</a>)</li>
              </ul>
              <p className="mt-3">To exercise your rights, contact us at: <a href="mailto:temmonteppo@gmail.com" className="text-primary underline">temmonteppo@gmail.com</a></p>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">7. Data Security</h2>
              <p>
                We handle personal data with due care and ensure appropriate protection of data processed through our systems. Access to data is restricted to authorized personnel only.
              </p>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">8. Cookies</h2>
              <p>
                This website does not use cookies or third-party tracking technologies.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
